module.exports = __webpack_public_path__ + "images/zoomed-first.png";